



























import Vue from 'vue'
import PageDefaultLayout from '@/components/globals/PageDefaultLayout.vue'
import snackbar from '@/tools/snackbar'
import { passwordResetEmail } from '@/core/Auth'
import showErrorDialog from '@/tools/error-dialog'
import * as Sentry from '@sentry/browser'
import PasswordRecoveryForm from '@/components/help/PasswordRecoveryForm.vue'

export default Vue.extend({
  components: {
    PageDefaultLayout,
    PasswordRecoveryForm,
  },
  data() {
    return {
      asyncErrors: {},
      isSubmitting: false,
    }
  },
  methods: {
    async onSendMail(email: string) {
      this.isSubmitting = true
      try {
        await passwordResetEmail(email)
        snackbar({ text: 'メールを送信しました' })
        if (!this.$store.getters['auth/isLogin']) {
          this.$router.push('/login')
        } else {
          this.$router.push('/me/profile')
        }
      } catch (error) {
        if (error.status === 422) {
          this.asyncErrors = error.errors
          return
        }
        Sentry.captureException(error)
        showErrorDialog({ msg: 'メールの送信に失敗しました。' })
      } finally {
        this.isSubmitting = false
      }
    },
  },
})
